import { useState } from "react";
import AdminLayout from "../../components/admin/AdminLayout";
import AdminBlogList from "../../components/AdminBlogList";
import AdminBlogEditor from "../../components/AdminBlogEditor";

export default function AdminBlog() {
  const [view, setView] = useState("list");
  const [editingId, setEditingId] = useState(null);

  return (
    <AdminLayout>
      {view === "editor" ? (
        <AdminBlogEditor
          postId={editingId}
          onBack={() => {
            setView("list");
            setEditingId(null);
          }}
          onSaved={() => {
            setView("list");
            setEditingId(null);
          }}
        />
      ) : (
        <AdminBlogList
          onNew={() => {
            setEditingId(null);
            setView("editor");
          }}
          onEdit={(id) => {
            setEditingId(id);
            setView("editor");
          }}
        />
      )}
    </AdminLayout>
  );
}
